import script from "./V2ParentView.vue?vue&type=script&setup=true&lang=js"
export * from "./V2ParentView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__